<template>
	<div
		class="receipt-sidebar p palm-p- pv- ph-- mb u-line-height--comfy"
		:class="{ 'is-small': isSmall, 'no-phone': noPhone, 'phone-only': phoneOnly }"
		v-if="metaData && !hidePoweredBy"
	>
		<div
			class="layout p- palm-pv-- layout--middle layout--flush layout--flex layout--flex-wrap u-palm-text-align--center"
			v-if="!phoneOnly"
		>
			<div
				class="layout__item u-1/1-palm u-palm-text-align--center layout__item--flex-fill pr- u-1/2 u-1/2-lap"
				:class="{ 'u-1/3': !isSmall, 'u-1/3-lap': isFull }"
			>
				<div class="c-ekomi palm-mr0">
					<div>
						<div
							:style="`background-image:url(${ekomiWidgetData.logo})`"
							class="c-ekomi__logo u-float--left mr"
						></div>
						<div class="u-float--left c-ekomi__text mt--">
							<div class="c-star-rating">
								<span class="c-star-rating__empty"></span>
								<span
									class="c-star-rating__full"
									:style="`width: ${ekomiWidgetData.widthPercentage}%`"
								></span>
							</div>
							<div class="c-ekomi__rating delta">
								<span>{{ ekomiWidgetData.score }}</span>
								<span class="u-text-color-grey--light">/10</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="layout__item u-1/1-palm layout__item--flex-fill palm-pv"
				:class="{ 'u-1/3': !isSmall, 'u-1/2 u-1/1-lap pt u-palm-text--center': isSmall }"
			>
				Powered by &nbsp;&nbsp;
				<img height="35" src="@/assets/img/logos/logo-internal/logo-gaslicht.svg" alt="Logo Gaslicht.com" />
			</div>
			<div
				class="layout__item portable-pl0 u-1/1-palm layout__item--flex-fill"
				v-if="!isSmall && !phoneOnly"
				:class="{ 'u-1/1 u-1/3-lap ': isSmall, 'u-1/3': !isSmall, 'u-1/3-lap': isFull }"
			>
				<template v-if="!noPhone">
					{{ metaData.Openinghours.Text }}
					<div class="mt--">
						<span
							v-if="metaData.Openinghours.Value"
							class="u-text-color-status--error small"
							:class="{ 'u-text-color-status--green': metaData.Openinghours.Value === 'open' }"
							v-tooltip="
								metaData.Openinghours.Value === 'open'
									? 'Wij zijn op dit moment telefonisch bereikbaar.'
									: 'Wij zijn op dit moment niet bereikbaar'
							"
						>
							<svg height="9" width="10">
								<circle cx="4" cy="4" r="4" class="u-svg-fill" />
							</svg>
						</span>
						<a class="mr-- mt0 mb-- small" :href="'tel:' + phone.replace(/ /g, '').replace('-', '')">{{
							phone
						}}</a>
						<template v-if="whatsapp != null && whatsapp != ''">
							<span class="mh-">&nbsp;</span>
							<span class="u-white-space--nowrap small">
								<img src="@/assets/img/icons/whatsapp.svg" height="14" alt="Logo WhatsApp" />
								<a
									class="ml-- mt0 mb-- u-display--inline-block small"
									:href="'tel:' + whatsapp.replace(/ /g, '').replace('-', '')"
									>{{ whatsapp }}</a
								>
							</span>
						</template>
					</div>
				</template>
				<template v-else>
					<p class="mb0">
						Deze informatie wordt verzameld, aangeboden en verzorgd door Gaslicht.com. Alle informatie valt
						derhalve onder de verantwoordelijkheid van
						<a href="https://www.gaslicht.com/" target="_blank" class="u-text-decoration--underline"
							>Gaslicht.com</a
						>.
					</p>
				</template>
			</div>
		</div>
		<div class="layout layout--middle layout--flush">
			<div
				class="layout__item u-1/1-palm p-"
				v-if="phoneOnly || isSmall"
				:class="{ 'u-1/1 pt-  u-text-align--center': isSmall, 'u-1/3': !isSmall }"
			>
				<template v-if="!noPhone">
					{{ metaData.Openinghours.Text }}
					<div class="mt--">
						<span
							v-if="metaData.Openinghours.Value"
							class="u-text-color-status--error small"
							:class="{ 'u-text-color-status--green': metaData.Openinghours.Value === 'open' }"
							v-tooltip="
								metaData.Openinghours.Value === 'open'
									? 'Wij zijn op dit moment telefonisch bereikbaar.'
									: 'Wij zijn op dit moment niet bereikbaar'
							"
						>
							<svg height="9" width="10">
								<circle cx="4" cy="4" r="4" class="u-svg-fill" />
							</svg>
						</span>
						<a class="mr-- mt0 mb-- small" :href="'tel:' + phone.replace(/ /g, '').replace('-', '')">{{
							phone
						}}</a>
						<span class="mh-">&nbsp;</span>
						<template v-if="whatsapp != null && whatsapp != ''">
							<span class="u-white-space--nowrap small">
								<img src="@/assets/img/icons/whatsapp.svg" height="14" alt="Logo WhatsApp" />asd
								<a
									class="ml-- mt0 mb-- u-display--inline-block small"
									:href="'tel:' + whatsapp.replace(/ /g, '').replace('-', '')"
									>{{ whatsapp }}
								</a>
							</span>
						</template>
					</div>
				</template>
				<template v-else>
					<p>
						Deze informatie wordt verzameld, aangeboden en verzorgd door Gaslicht.com. Alle informatie valt
						derhalve onder de verantwoordelijkheid van
						<a href="https://www.gaslicht.com/" target="_blank">Gaslicht.com</a>
					</p>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import Api from '@/services/api.energy';

export default {
	props: {
		isSmall: {
			type: Boolean,
			default: false,
		},
		isFull: {
			type: Boolean,
			default: false,
		},

		phoneOnly: {
			type: Boolean,
			default: false,
		},
	},
	mounted: async function () {},
	created: async function () {
		if (!this.hidePoweredBy) {
			let metaData = await Api.getMetaData(null);
			this.metaData = metaData;

			// eslint-disable-next-line
			if (APP_CLIENTID == 'bdu') {
				this.metaData = {
					Openinghours: {
						Text: 'Vragen? U kunt ons bellen op',
					},
				};
			}

			let ekomiCijfer = metaData.EkomiWidget[1].Value;
			this.ekomiWidgetData.score = ekomiCijfer.substr(0, 3);
			this.ekomiWidgetData.logo = metaData.EkomiWidget[4].Value;
			this.ekomiWidgetData.widthPercentage = parseFloat(ekomiCijfer.replace(',', '.')) * 10;
		}
	},
	data: function () {
		return {
			ekomiWidgetData: {
				widthPercentage: 0,
				score: null,
				logo: null,
			},
			metaData: null,
			// eslint-disable-next-line
			phone: APP_PHONE,
			// eslint-disable-next-line
			whatsapp: APP_WHATSAPP,
			// eslint-disable-next-line
			hidePoweredBy: APP_HIDEPOWEREDBY,
			// eslint-disable-next-line
			noPhone: APP_NOPHONE,
		};
	},
};
</script>

<style scoped>
div {
	line-height: 1.4em;
}
</style>
